module.exports = __webpack_public_path__ + "static/img/zhongduan1.7288c1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homes/zhongduan1.png
// module id = 9DSc
// module chunks = 1